import React from "react";
import CardHeader from "./CardHeader/cardHeader";
import CardDataUser from "./CardDataUser/cardDataUser";
import CardGeneral from "./CardGeneral/cardGeneral";
import CardSearch from "./CardSearch/cardSearch";
import CardPartners from "./CardPartners/cardPartners";

function EditUserScreen(props) {
    return (
        <>
            <CardHeader />
            <CardDataUser />
            <CardGeneral />
            <CardSearch />
            <CardPartners />
        </>
    )
}

export default EditUserScreen;
